var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HistoryItem',_vm._b({ref:"history_item"},'HistoryItem',_vm.$props,false),[_c('span',[_vm._v(_vm._s(_vm.state))]),_c('HistoryItemFunctions',[_vm._t("history_item_functions"),_c('RemoveHistoryItem')],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }